import { ReactNode } from 'react';
import styled from 'styled-components';
import { semibold16 } from '@ardoq/typography';

export const ModalSubtitleStyle = styled.div`
  ${semibold16}
`;

export interface ModalSubtitleProps {
  children?: ReactNode;
}

/** @deprecated please use text for all the text content instead */
const ModalSubtitle = ({ children }: ModalSubtitleProps) => (
  <ModalSubtitleStyle>{children}</ModalSubtitleStyle>
);

export { ModalSubtitle };
